import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/svg/ourForest/IconTreeForest.svg'
import _imports_1 from '@/assets/svg/ourForest/IconTreeArea.svg'


const _hoisted_1 = {
  key: 0,
  class: "container mx-auto w-full px-4 lg:(w-8/12 px-0)"
}
const _hoisted_2 = { class: "flex border-b border-gray-200 pb-4 mb-6 flex-wrap items-center" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "flex text-primary-dark font-semibold ml-3 lg-text-32px text-24px" }
const _hoisted_6 = { class: "md:ml-auto lg:mt-0 mt-2 lg:pl-0 md:pl-4 pl-0 flex" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Go to map ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Annual Reports ")
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "flex relative items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-12 h-12 rounded-full flex items-center justify-center z-10 bg-white",
  style: {"border":"1px solid #dfe1e6"}
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    })
  ])
], -1)
const _hoisted_12 = {
  class: "bg-primary-dark py-1 pl-8 pr-4 absolute ml-7 rounded-3xl",
  style: {"height":"fit-content"}
}
const _hoisted_13 = { class: "font-medium text-white" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)

import useForest from '@/composables/useForest';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { forestDetail } = useForest();
const formatNumber = (number: number) => {
  return number.toLocaleString();
};

const openMap = () => {
  window.open(
    `https://www.google.com/maps/search/?api=1&query=${forestDetail.value.latitude},${forestDetail.value.longitude}`
  );
};

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(forestDetail))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(forestDetail).name) + "," + _toDisplayString(_unref(forestDetail).country), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_BaseButton, {
              onClick: openMap,
              "data-testid": "go-map",
              "color-scheme": "primary-dark",
              style: {"font-weight":"700 !important"}
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: `/landing/report/${_unref(forestDetail).id}`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_BaseButton, {
                  "data-testid": "annual-report",
                  "color-scheme": "border",
                  class: "ml-4",
                  style: {"font-weight":"700 !important"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        _createElementVNode("div", {
          class: "mb-6",
          innerHTML: _unref(forestDetail).description
        }, null, 8, _hoisted_9),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, [
              _createTextVNode(_toDisplayString(formatNumber(_unref(forestDetail).area_size)) + " ft", 1),
              _hoisted_14
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})